// extracted by mini-css-extract-plugin
export default {"panel":"NotchedPanel_panel__qsStV","shape":"NotchedPanel_shape__4P939"};